const TestimonialsDoubleQuotes = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="44"
      viewBox="0 0 48 44"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1185 43.3611V22.7475H10.2381C10.2381 19.4458 10.866 16.6794 12.1218 14.4485C13.3776 12.1284 15.7098 10.3883 19.1185 9.22821V0.393799C16.3377 0.750745 13.7364 1.59849 11.3145 2.93704C8.98229 4.18635 6.96403 5.7926 5.25971 7.7558C3.5554 9.71901 2.2099 11.9945 1.22319 14.5824C0.326184 17.1702 -0.0774685 19.9366 0.0122319 22.8814V43.3611H19.1185ZM47.7778 43.3611V22.7475H38.8974C38.8974 19.4458 39.5253 16.6794 40.7811 14.4485C42.0369 12.1284 44.3692 10.3883 47.7778 9.22821V0.393799C44.9971 0.750745 42.3957 1.59849 39.9738 2.93704C37.6416 4.18635 35.6234 5.7926 33.919 7.7558C32.2147 9.71901 30.8692 11.9945 29.8825 14.5824C28.9855 17.1702 28.5819 19.9366 28.6716 22.8814V43.3611H47.7778Z"
        fill="white"
        opacity="0.2"
      />
    </svg>
  );
};
export default TestimonialsDoubleQuotes;
